import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { fetchApi } from '../../utlis/axios'; 

import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

const DonationDetail = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [donation, setDonation] = useState([]);
  const [refreshing, setRetreshing]=useState(false)
  const getStatus = async () => {
    try {
      const result = await fetchApi.get('/donation-graph', {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        const donationDataResponse = result.data;
        const monthlyDonation = {};
        const currentYear = new Date().getFullYear();

        donationDataResponse.forEach((donation) => {
          const createdDate = new Date(donation.created_at);
          const donationYear = createdDate.getFullYear();

          if (donationYear === currentYear && donation.type) {
            const month = createdDate.toLocaleString('en-US', { month: 'long' });

            if (monthlyDonation[month]) {
              if (donation.type === 'food') {
                monthlyDonation[month].food++;
              } else if (donation.type === 'education') {
                monthlyDonation[month].education++;
              } else if (donation.type === 'health') {
                monthlyDonation[month].health++;
              } else if (donation.type === 'bussiness') {
                monthlyDonation[month].business++;
              } else if (donation.type === 'others') {
                monthlyDonation[month].other++;
              }
            } else {
              monthlyDonation[month] = {
                food: 0,
                education: 0,
                health: 0,
                business: 0,
                other: 0,
              };
              if (donation.type === 'Food') {
                monthlyDonation[month].food++;
              } else if (donation.type === 'Education') {
                monthlyDonation[month].education++;
              } else if (donation.type === 'Health') {
                monthlyDonation[month].health++;
              } else if (donation.type === 'Business') {
                monthlyDonation[month].business++;
              } else if (donation.type === 'Other') {
                monthlyDonation[month].other++;
              }
            }
          }
        });

        const allMonths = Array.from({ length: 12 }, (_, i) => {
          const monthName = new Date(null, i).toLocaleString('en-US', {
            month: 'long',
          });
          return {
            month: monthName,
            ...monthlyDonation[monthName],
          };
        });

        setDonation(allMonths);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getStatus();
  }, []);

  async function handleRefresh(params) {
    setRetreshing(true)
    await getStatus()
    setRetreshing(false)
  }

  const data = {
    labels: donation.map((entry) => entry.month),
    datasets: [
      {
        label: 'Food',
        data: donation.map((entry) => entry.food),
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        type: 'line',
      },
      {
        label: 'Education',
        type: 'line',
        data: donation.map((entry) => entry.education),
        borderColor: 'orange',
        fill: false,
        yAxisID: 'y-axis-1',
      },
      {
        label: 'Business',
        type: 'line',
        data: donation.map((entry) => entry.business),
        borderColor: '#4db199',
        fill: false,
        yAxisID: 'y-axis-1',
      },
      {
        label: 'Health',
        type: 'line',
        data: donation.map((entry) => entry.health),
        borderColor: '#e19595', // Adjust color as needed
        fill: false,
        yAxisID: 'y-axis-1',
      },
      {
        label: 'Other',
        type: 'line',
        data: donation.map((entry) => entry.other),
        borderColor: '#8c9efd', // Adjust color as needed
        fill: false,
        yAxisID: 'y-axis-1',
      },
    ],
  };

  const options = {
    scales: {
      type: 'category',
      y: {
        beginAtZero: true,
        ticks: {
          color: '#000',
          font: {
            size: 12,
          },
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      x: {
        ticks: {
          color: '#000',
          font: {
            size: 12,
          },
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,        
          usePointStyle: false,
          boxHeight: 15,   
          padding: 10,
          color: "#000",
          font: { 
            size: 14, 
            weight: "500",
            family: "'Plus Jakarta Sans', sans-serif"       
          },
        },
      },
      
    },
  };

  return (
    <div className='w-full bg-white sm:p-5 p-2.5 rounded-xl shadow sm:mt-6 mt-4'>
    <div className='dashboardCard'>
      <div className='flex items-center gap-2 justify-between'>
      <p style={{color:'black', fontSize:'20px'}} className='font-semibold mb-2'>
        Donation Allocation By Category
        </p>
        <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
      </div>
      
    <Link to='/donationdetailpage'>
    <div className='dashboard-responsive'>
      <Bar data={data} options={options} height={430} />
    </div>
    </Link>
    </div>
    </div>
  );
};

export default DonationDetail;
